import Component from "~/components/ui/Breadcrumb"

/** @titleBy name */
export interface Item {
    /**
     * @title Nome
     */
    name: string

    /**
     * @title URL
     */
    item?: string
}

export interface Props {
    items: Item[]
}

export default function Breadcrumb({ items }: Props) {
    const mappedItems = items.map(({ name, item = '/' }, index) => ({
        '@type': 'ListItem' as const,
        name,
        item,
        position: index,
    }))

    return (
        <div className='max-w-[1810px] mx-auto px-3 my-5'>
            <Component itemListElement={mappedItems} />
        </div>
    )
}
